import React, { Component } from "react";
import { connect } from "react-redux";
import LinkButton from "./LandingPage/LinkButton";
import { withTranslation } from "react-i18next";
import CreateAddPaymentConfirmationAction from "../store/actionCreators/CreateAddPaymentConfirmationAction";
import CreateAddPaymentFailureAction from "../store/actionCreators/CreateAddPaymentFailureAction";

class AddReviewAndDeclarations extends Component {

    render() {
        const { t } = this.props;



        // apply/make-payment/id test page

        return (
            <React.Fragment>

                <div className="form-group">

                    <label id="ProgrammedLabel"> Make Payments here (Devs Only).... </label>
                    <br />
                    <br/>

                </div>

                <div className="my-3">
                    <button
                        id="addPaymentSuccessButton"
                        className="btn btn-primary"
                        onClick={
                            () => { this.props.addPaymentConfimration(this.props.licenceApplicationId, this.props.vesselId, this.props.paymentAmount) }
                        }>
                        Submit payment
                    </button>

                </div>
                <div className="mb-3">
                    <LinkButton
                        id="gotoPaymentSuccessButton"
                        to={this.props.parentRoute + "/payment-success"}
                        className="btn btn-secondary">
                        Goto Success Page
                    </LinkButton>
                </div>
                <br/>
            </React.Fragment>
        );
    };
}

// map redux state attributes to this view's property collection.
const mapStateToProps = (state, ownProps) => {
    return {
        licenceApplicationId: state.currentApplication.id || 0,
        vesselId: state.currentVessel.id || 0,
        paymentAmount: state.paymentAmount
    };
};


const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        addPaymentConfimration: (licenceApplicationId, vesselId, paymentAmount) => {
            dispatch(CreateAddPaymentConfirmationAction(licenceApplicationId, vesselId, paymentAmount));
        },
        addPaymentFailure: (licenceApplicationId, vesselId) => {
            dispatch(CreateAddPaymentFailureAction(licenceApplicationId));
        }

    }
}

const languageAwareComponent = withTranslation()(AddReviewAndDeclarations);
export default connect(mapStateToProps, mapDispatchToProps)(languageAwareComponent);

